import React from 'react';

import { ReactComponent as EmptyCheckbox } from 'assets/icons/ic_check_empty.svg';
import { ReactComponent as CheckedCheckbox } from 'assets/icons/ic_check_fill.svg';
import { twMerge } from 'tailwind-merge';

interface CheckboxInputProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  children: React.ReactNode;
  className?: string;
  checkboxClassName?: string;
}

const CheckboxInput = ({ checked, setChecked, children, className, checkboxClassName }: CheckboxInputProps) => {
  return (
    <div
      className={twMerge('flex w-fit cursor-pointer items-center gap-x-2.5', className)}
      onClick={() => setChecked(!checked)}
    >
      {checked ? (
        <CheckedCheckbox className={twMerge('mt-px', checkboxClassName)} width={16} height={16} />
      ) : (
        <EmptyCheckbox className={twMerge('mt-px', checkboxClassName)} width={16} height={16} />
      )}
      <div>{children}</div>
    </div>
  );
};

export default CheckboxInput;
